import axios from "axios";
import {
    IP
} from "../index";


// 查询临床指南
export async function selectClinicalGuidelines(data) {
    var resp = await axios.post(`${IP}/admin/clinicalGuidelines/select`, {
        ...data
    });
    return resp.data;
}
// 新增临床指南
export async function addClinicalGuidelines(data) {
    var resp = await axios.post(`${IP}/admin/clinicalGuidelines/add`, data);
    return resp.data;
}
// 修改临床指南
export async function updateClinicalGuidelines(data) {
    var resp = await axios.post(`${IP}/admin/clinicalGuidelines/update`,data);
    return resp.data;
}
// 删除临床指南
export async function deleteClinicalGuidelines(id) {
    var resp = await axios.post(`${IP}/admin/clinicalGuidelines/delete`, {
        id
    });
    return resp.data;
}